import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

// eslint-disable-next-line react/prop-types
const ImageWithPreview = ({ src, alt = "", ...props }) => {
  const [open, setOpen] = useState(false);

  // const handleDownload = async (e) => {
  //   e.stopPropagation();
  //   try {
  //     const response = await fetch(src, { mode: 'cors' });
  //     const blob = await response.blob();
  //     const url = window.URL.createObjectURL(blob);
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.download = alt || "image";
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     window.URL.revokeObjectURL(url);
  //   } catch {
  //     alert("Không thể tải ảnh. Có thể ảnh bị chặn bởi CORS hoặc link không hợp lệ.");
  //   }
  // };

  return (
    <>
      <img
        {...props}
        src={src}
        alt={alt}
        className={
          (props.className || "") +
          " rounded-lg w-full aspect-square md:w-40 md:h-40 lg:w-40 lg:h-40 shadow-md border border-gray-200 cursor-pointer hover:opacity-80 object-cover"
        }
        loading="lazy"
        onClick={() => setOpen(true)}
      />
      {open && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80"
          onClick={() => setOpen(false)}
        >
          <div className="relative" onClick={e => e.stopPropagation()}>
            <img
              src={src}
              alt={alt}
              className="max-w-[90vw] max-h-[80vh] rounded-lg shadow-lg"
            />
            <button
              onClick={() => setOpen(false)}
              className="absolute top-1 right-1 transition"
              aria-label="Đóng"
            >
              <FontAwesomeIcon icon={faXmark} className="size-5 text-white p-1 bg-black rounded-full bg-opacity-65"/>
            </button>
            {/* <button
              onClick={handleDownload}
              className="absolute bottom-2 right-2 bg-blue-600 bg-opacity-80 text-white rounded-full p-2 hover:bg-blue-800 transition group"
              aria-label="Tải xuống"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m0 0l-6-6m6 6l6-6" />
              </svg>
              <span className="absolute bottom-12 right-1/2 translate-x-1/2 opacity-0 group-hover:opacity-100 pointer-events-none bg-gray-800 text-white text-xs rounded px-2 py-1 transition whitespace-nowrap z-50">
                Tải xuống
              </span>
            </button> */}
          </div>
        </div>
      )}
    </>
  );
};

export default ImageWithPreview; 